module.exports = {
    alerts: {
        deleteFile: "Are you sure you want to delete this file?",
        error: "Error",
        success: "Successfully",
        warning: "Alert",
        unknownError: "Unknown error",
        fileNotFound: "File not found!",
        fileNotUploaded: "File not uploaded!",
        fileNotDeleted: "File not deleted!",
        newAccessRequestTitle: "New access request!",
        newAccessRequestBody: "The distributor wants to access the customer"
    },
    asks: {
        warning: "Warning",
        confirmCuttingTitle: "Send it to be cut?",
        confirmCuttingText: "The order will be moved to \"New\" and all assemblers will receive a notification.",
        confirmCuttingDoneTitle: "Finish cutting?",
        confirmCuttingDoneText: "The order will be marked as \"Completed\".",
        delete_status: "Are you sure you want to delete the user status?",
        confirmTakeOrder: "Do you really want to take the order to work?",
        confirmWasCutReminder: "You are changing the status to 'Completed', but you didn't click the 'Pattern Cut' button. The pattern will not be marked as cut. Continue anyway?",
        deleteUser: "Are you sure you want to delete a user?",
        confirmClone: "Do you really want to clone this order?",
        delete_file: "Are you sure you want to delete a file?",
        deleteCut: "Really delete a pattern?",
        deleteNoteTitle: "Delete note?",
        requestNoteDeletionTitle: "Send a deletion request?",
        requestNoteDeletionText: "The note will be deleted after admin approval."
    },
    buttons: {
        clearFilter: "Clear",
        reply: "Reply",
        reaction: "Reaction",
        sendAccessRequest: "Send an access request",
        reloadPage: "Reload the page",
        recordAudioNote: "Record a voice message",
        stopRecording: "Stop recording",
        stop: "Stop",
        sendToCutting: "Send for cutting",
        cuttingDone: "The pattern has been cut (Finish)",
        imHere: "I'm here!",
        clearStatus: "Reset status",
        addStatus: "Add status",
        add: "Add",
        addClient: "Add Client",
        addNote: "Add note",
        acknowledged: "Acknowledged",
        addOrder: "Add Order",
        addUser: "Add User",
        apply: "Apply",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        deleteClient: "Delete client",
        deleteOrder: "Delete order",
        edit: "Edit",
        editOrder: "Edit Order",
        logoutBtn: "Log out",
        show: "Show",
        hide: "Hide",
        send: "Send",
        save: "Save",
        subscribeUser: "Subscribe to notifications",
        takeToWork: "Take to work",
        unsubcribeUser: "Unsubscribe from notifications",
        update: "Update",
        clone: "Clone",
        downloadAllCuts: 'Download all cuts',
        loading: "Loading...",
        selectPatterns: "Select patterns from database"
    },
    days: {
        friday: "Friday",
        monday: "Mon",
        saturday: "Sat",
        sunday: "Sun",
        thursday: "Thur",
        tuesday: "Tue",
        wednesday: "Wed"
    },
    errors: {
        notificationNotSupported: "Your browser does not support notifications",
        serviceWorkerNotSupported: "Your browser does not support Service Worker",
        pushManagerNotSupported: "Your browser does not support push notifications",
        notificationPermissionRequired: "Required permission to display notification",
        serviceWorkerTimeout: "Service Worker timeout",
        subscriptionFailed: "Failed to subscribe",
        unsubscribeFailed: "Failed to subscribe",
        notificationRequestPermission: "Permission for notification was not granted",
        subcriptionToServer: "Error when subscribing to notifications:",
        user_already_exists: "User already exist",
        invalid_request: "Invalid request",
        user_not_found: "User not found",
        user_updated: "User sucessfully updated",
        wrong_password: "Wrong password",
        invalid_data: "Invalid data",
        access_denied: "You don't have access to this feature",
        invalid_token: "Invalid token",
        not_found: "No record found",
        create_failed: "Create error",
        update_failed: "Update error",
        delete_failed: "Error deleting",
        unknown_error: "Uknown error",
        order_delete_failed: "Couldn't delete the order!"
    },
    headings: {
        draftsmenStats: "Draftsmen Statistics",
        anomalousSessions: "Anomalous sessions (≥ 8 h)",
        completedOrders: "Completed Orders",
        clientOrder: "Client's order",
        newOrders: "New Orders",
        orderData: "Order Data",
        carData: "Car",
        statusSection: "Status & patterns availability",
        actors: "Client & manager",
        ordersForPeriod: "Orders for the period",
        ordersInProgress: "Orders in Progress"
    },
    labels: {
        replyPhoto: "Photo",
        replyVideo: "Video",
        replyVoice: "Voice message",
        replyMedia: "Media",
        replyUser: "User",
        replyTo: "Reply to",
        editMessage: "Editing message",
        clientOwner: "Distributor Client",
        clientNotes: "Client notes",
        clientNote: "Client note",
        problemPattern: "Problematic pattern",
        problemPackaging: "Packaging problem",
        wasCut: "Pattern was cut",
        hasNoPatterns: "No patterns",
        patternRequestSent: "Pattern request sent",
        noPatternsSelectStatus: "Select the no-patterns status",
        noPatternsNoneInAny: "No patterns in any database",
        noPatternsNoneInOurs: "No patterns in our databases",
        noPatternsPartial: "Patterns partially available",
        noPatternsPartialBadge: "Partial",
        assemblyProgram: "Assembly program",
        assemblyProgramSelect: "Select assembly program",
        assemblyProgramHint: "You can select several. Programs from cuts are pulled in automatically and are managed in the cuts.",
        assemblyProgramLocked: "Set on a cut — change it in the cuts",
        assembledIn: "Assembled in program",
        filterNoPatternsPartial: "Patterns partially available",
        filterNoPatternsLabel: "Patterns availability",
        filterAssemblyProgramAll: "Assembly program: all",
        filterNoPatternsAllOrders: "Patterns: all orders",
        filterNoPatternsAny: "No patterns (all)",
        manualTitle: "Enter the name manually",
        unknown: "Unknown",
        unknownModel: "I don't know the model/year or model is missing",
        pattern: "Pattern",
        files: "Files",
        accessTo: "Access to",
        created: "Created",
        processed: "Processed",
        waitingConfirmation: "Awaiting confirmation",
        listened: "Listened to",
        audioNotes: "Voice messages",
        cutting: "Cutting",
        setStatus: "Status",
        onlineUsers: "Who's online",
        addAutomatically: "To be added automatically",
        addCutToOrder: "Add cut to order",
        order_deleted: "Deleting an order",
        toWorkPt1: "The order",
        toWorkPt2: "has been accepted",
        carPhotos: "Car photo",
        customPeriod: "Period",
        editCut: "Edit Cut",
        filmLength: "Film length",
        filmWidth: "Film width",
        filmCutsForOrder: "Film cuts to order",
        isActiveUser: "The user is active",
        orderFiles: "Files for ordering",
        orders: "Orders",
        orderViewedBy: "The order is viewed by:",
        orderStatus: "Order status",
        orderFromDistributor: "Order from distributor",
        phone: "Phone",
        shortDescription: "Short description",
        lastUpdate: "Last update",
        totalFilmArea: "Total film area",
        userGroup: "User Group",
        urgent: "Urgent!",
        changeHistory: "History of changes",
        badge: "Badge",
        translations: "Translations",
        select_value: "Select value"
    },
    log: {
        yes: "Yes",
        no: "No",
        subcriptionUnsubscribe: "The subscription has been canceled.",
        orderUrgent: "Urgent order",
        orderNotUrgent: "Non-urgent order",
        notePrefix: "Note",
        noItems: "None",
        allCutsDeleted: "All patterns deleted",
        fields: {
            title: "Name",
            description: "Note",
            status: "Status",
            isUrgent: "Urgency",
            clientId: "Client",
            managerId: "Manager",
            image: "Images",
            file: "Files",
            cuts: "Film segments for order",
            hasProblematicPattern: "Problematic pattern",
            hasProblematicPackaging: "Packaging issue",
            wasCut: "Pattern cut",
            wasCutBadge: "Cut",
            hasNoPatterns: "No patterns",
            noPatternsType: "No-patterns status",
            patternRequestSent: "Pattern request sent",
            assemblyPrograms: "Assembly program"
        }
    },
    units: {
        m: "m"
    },
    messages: {
        downloadingPatterns: "Uploading patterns to the server...",
        selectModelOrCheckUnknown: "Please select the car model and year, or check 'I don't know the model/year'.",
        nothingFound: "Nothing found",
        cutsSaving: "Saving film cuts…",
        cutsSaved: "Film cuts saved",
        cutsSaveError: "Failed to save film cuts",
        anomalyExcluded: "Sessions ≥ 8 h are excluded from work time",
        carChangedDeletePatterns: "You have selected a different model. Previous patterns will be deleted. Continue?",
        accessRequestSent: "Your request has been successfully sent! Please wait for confirmation.",
        requestFailed: "Error sending request",
        accessGranted: "Access granted",
        accessRejected: "Request denied",
        noRequests: "No requests",
        noClientNotes: "No notes yet",
        noteDeletionRequestSent: "Deletion request sent to admin",
        noteDeletionRequestPending: "A deletion request for this note has already been sent",
        noteDeletionApproved: "Note deleted",
        noteDeletionRejected: "Request rejected",
        noNoteDeletionRequests: "No note deletion requests",
        noMicrophoneAccess: "Microphone access is prohibited",
        audioRecordTooShort: "The recording is too short, nothing was downloaded.",
        orderCuttingDone: "Done!",
        orderSentToCutting: "Sent!",
        statusUpdated: "Status updated",
        statusCreated: "Status created",
        noManagersOnline: "No managers online",
        noDraftsmenOnline: "No draftmans online",
        fileDeleted: "File {name} successfully deleted",
        isUrgent: "The order is urgent",
        uploadedFiles: "Files uploaded",
        uploadedImages: "Images uploaded",
        deleteClientMsg: "You really want to delete a client",
        successfullyDeleteClientMsg: "Client deleted successfully",
        errorDeleteClient: "Error when deleting a client",
        clientHasOrders: "The customer has an order, deletion is not possible!",
        cutDeleted: "Pattern deleted",
        confirmDeleteOrderPt1: "you really want to delete the order",
        confirmDeleteOrderPt2: "This will delete all the data associated with it",
        userDeleted: "User successfully removed",
        onlyImageDownload: "You can only download the image!",
        fileTooLarge: "File size exceeds the allowed limit",
        invalidFileType: "Invalid file type",
        confirmImageDelete: "Are you sure you want to delete the image?",
        orderUpdated: "Order successfully updated",
        orderCloned: "Order successfully cloned",
        noChanges: "No changes",
        noResults: "Nothing found. Try changing your query.",
        firstSearchResults: "The first 50 results are shown. Continue typing to refine your search...",
        selectNoPatternsStatus: "Please select the no-patterns status."
    },
    modal: {
        chatErrorTitle: "Chat error",
        chatErrorText: "The message could not be sent. There seems to be a connection error. Please refresh the page.",
        editStatus: "Edit status",
        addStatus: "Add status",
        addOrder: "Add Order",
        editOrder: "Edit Order",
        inactivityTitle: "Are you still here?",
        inactivityText: "We noticed that you have been inactive for 15 minutes.",
        inactivitySubtext: "If you have left, please set the appropriate status so that your colleagues are aware.",
    },
    months: {
        april: "Apr",
        august: "Aug",
        december: "Dec",
        february: "Feb",
        january: "Jan",
        july: "Jul",
        june: "Jun",
        march: "Mar",
        may: "May",
        november: "Nov",
        october: "Oct",
        september: "Sep"
    },
    navbar: {
        adminPanel: "Admin panel",
        allOrderList: "List of all orders",
        mainPage: "Home",
        myClients: "My clients",
        draftsmenStats: "Draftsman stats"
    },
    placeholders: {
        selectDraftman: "Search draftsman",
        search: "Search...",
        selectBrand: "Select brand",
        selectModel: "Select model",
        selectYear: "Select year",
        recordingInProgress: "Recording is in progress...",
        DraftsManName: "Drafts Man Name",
        carBrandModel: "Car model and brand",
        clientName: "Client Name",
        clientPhone: "Client Phone",
        clientStatus: "Client Status",
        clientNote: "E.g.: Always without turn signals",
        managerName: "Manager Name",
        orderDescription: "Order description",
        searchClientByName: "Search client by name",
        searchUserByName: "Search user by name",
        selectClient: "Select a client",
        selectDraftsman: "Search draftsman",
        selectFiles: "Select a file",
        selectManager: "Select a manager",
        userLogin: "User Login",
        userPassword: "User Password",
        writeMessage: "Write a message..."
    },
    ranges: {
        last7: "Last 7 days",
        thisMonth: "For this month",
        lastMonth: "For the last month",
        thisYear: "For the year",
        allTime: "All time",
        today: "Today",
        yesterday: "Yesterday"
    },
    tableheadings: {
        requests: "Requests from distributors",
        noteDeletionRequests: "Note deletions",
        noteDeletionHistory: "Deleted notes history",
        badges: "Badges",
        statusName: "Status name",
        statusColor: "Status color",
        statusRole: "Status role",
        actions: "Actions with status",
        color: "Color",
        role: "Role",
        statuses: "List of statuses",
        draftsman: "Draft Man",
        distributor: "Distributor",
        added: "Added",
        client: "Client",
        clients: "Clients",
        closed: "Closed",
        completed: "Completed",
        completedOrders: "Completed",
        totalTime: "Work Time",
        reprocessedOrders: "Reprocessed",
        anomalies: "Anomalies",
        reprocessTime: "Reprocess Time",
        averageTime: "Avg. Time",
        longestTime: "Longest Time",
        created: "Created",
        date: "Date",
        edited: "Edited",
        history: "History",
        manager: "Manager",
        name: "Name",
        note: "Note",
        notes: "Notes",
        status: "Status",
        title: "Title",
        type: "Type",
        user: "User",
        users: "Users",
        all: "All",
        preview: "Preview",
        table_actions: "Actions"
    },
    titles: {
        printImage: "Print a picture",
        attentionNotes: "Attention! Notes here",
        mainNote: "Main note"
    },
    statuses: {
        cutting: "Pattern cutting",
        active: "New order",
        closed: "Closed",
        done: "Done",
        work: "In progress",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected"
    },
    auth: {
        loginLabel: "Your login",
        loginRequired: "Write your login",
        passwordLabel: "Password",
        passwordPlaceholder: "Write your password",
        loginButton: "Log in",
        loginNote: "Login information can be obtained from the administrator",
        registerTitle: "Registration in the system",
        yourLoginLabel: "Your login",
        usernamePlaceholder: "Create a login",
        yourPasswordLabel: "Your password",
        passwordCreatePlaceholder: "Create a password",
        passwordConfirmLabel: "Confirm your password",
        passwordConfirmPlaceholder: "Repeat your password",
        registerButton: "Register"
    },
    notifications: {
        order: "Order",
        draftsman: "DraftsMan",
        client: "Client",
        manager: "Manager",
        audioMessage: "Voice message",
        defaultTitle: "Message",
        testTitle: "Notifications test",
        testText: "Messages test!!!",
        newOrder: "New order",
        assignedToOrder: "You have been assigned to an order",
        takenToWork: "Order taket to work",
        orderDone: "Order is done",
        chatMessage: "New message in the chat",
        reminder: "You have orders that are not closed. Change their status"
    },
    operations: {
        create: "Create",
        update: "Update",
        delete: "Delete",
        get: "Get",
        getByType: "Get by type",
        getByDate: "Get by date",
        login: "Login",
        logout: "Logout",
        upload: "File upload",
        get_order: "Get order data",
        edit_order: "Edit order data",
        error: "Error in system",
    },
    time: {
        hours_short: "h",
        minutes_short: "m",
        seconds_short: "s",
        minutes: "minutes ago",
        minute: "1 minute ago",
        hours: "hours ago",
        hour: "1 hour ago",
        days: "days ago",
        day: "1 day ago",
        weeks: "weeks ago",
        week: "1 week ago",
        months: "months ago",
        month: "1 month ago"
    },
    logwords: {
        car: "Car",
        carBrand: "Car brand",
        carModel: "Car model",
        carYear: "Car year",
        user: "user",
        order: "order",
        current: "Images that have already been",
        client: "client",
        file: "file",
        file_added: "File added",
        was: "Was:",
        became: "Became:",
        deleted: "Deleted",
        added: "Added",
        existed: "Photos were"
    },
    common: {
        crud:{
            titles: {
                list: '{name} List',
                create: 'Create {name}',
                edit: 'Edit {name}',
                view: 'View {name}'
            }
        },

        created_success: '{name} was successfully created.',
        created_error: 'Error while creating {name}.',

        updated_success: '{name} was successfully updated.',
        updated_error: 'Error while updating {name}.',

        confirm_delete: 'Are you sure you want to delete {name}?',
        deleted_success: '{name} was successfully deleted.',
        deleted_error: 'Error while deleting {name}.',

        load_error: 'Error loading {name}.',
    },
    validation: {
        required: 'The field {field} is required.',
        email: 'Enter a valid email.',
        min: 'The minimum length of {field} is {min} characters.',
        max: 'The maximum length of {field} is {max} characters.',
        min_value: '{field} cannot be less than {min}.',
        max_value: '{field} cannot be greater than {max}.',
        confirmed: '{field} confirmation does not match.',
        numeric: '{field} must contain only numbers.',
        string: '{field} must be a string.',
        boolean: '{field} must be true or false.',
        array: '{field} must be an array.',
        integer: '{field} must be an integer.',
        date: '{field} must be a valid date.',
        url: '{field} must be a valid URL.',
        unique: '{field} must be unique.',
        exists: 'The selected value for {field} is invalid.',
        digits: '{field} must contain {digits} digits.',
        regex: '{field} has an invalid format.',
        phone: 'Enter a valid phone number.',
        same: '{field} and {other} must match.',
        in: 'Invalid value for {field}.',
        not_in: 'The value for {field} is not allowed.',
        between: '{field} must be between {min} and {max}.',
        file: '{field} must be a file.',
        mimes: 'The file in {field} must be of type: {types}.',
        size: 'The file size of {field} must be no more than {size} KB.'
    },
    table: {
        placeholders: {

            empty_heading: 'Data has not been added yet.',
            empty_description: 'As soon as the data is added, it will be displayed here!'
        }
    },
    sso: {
        "redirecting_title": "Redirecting...",
        "redirecting_text": "Logging into Delivery CRM",
        "error_title": "Error",
        "error_text": "Failed to generate login link. Please try again later."
    },
    patterns: {
        cutId: "Pattern ID:",
        meter: "Meter",
        "databaseTitle": "Patterns database",
        "searching": "Searching for matching patterns...",
        "openOnWebsite": "Open \"{brand} {model}\" on the patterns website",
        "notFound": "Unfortunately, no patterns were found for this model and year.",
        "viewPatterns": "View patterns",
        "openOnSite": "Open on website",
        "backToCars": "Back to cars list",
        "addedToCuts": "This pattern is added to cuts"
    }
};